export const aftcabinImageOptions = {
  angle: 'aftcabin',
  staticOptions: {
    Veneer: 1,
    Floorboard: 1,
    Handrail: 1,
    Worktop: 1,
    Fabric: 1,
    CupboardsSaloon: 1,
    CupboardsOwnersCabin: 1,
    FabricOwnersCabin: 1,
    FabricAftCabin: 1,
    AftCabinLayout: 1,
    Mast: 1
  },
  mattes: [
    {
      option: 'Veneer',
      dependency: null
    },
    {
      option: 'FabricAftCabin',
      dependency: null
    },
    {
      option: 'AftCabinLayout',
      dependency: 'FabricAftCabin'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X43MK2/views/aftcabin.js